import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import { IoLogoWechat } from 'react-icons/io5'

import useBar from './Bar'
import { toTelHref, copyTextToClipboardSilent } from '../../utils/utility'

export default function UserContactDetail({
  user,
  variant = 'body1',
  color = 'text.secondary',
  showEmail = true,
  showPhone = true,
  showWeChat = true,
  sx = { display: 'flex', alignItems: 'center', gap: 1, justifyContent: { xs: 'center', sm: 'flex-start' }, cursor: 'pointer', mt: 1 },
}) {
  const bar = useBar()

  if (!user) {
    return null
  }

  return (
    <Box sx={{ mt: 1 }}>
      {showEmail && (
        <Typography variant={variant} color={color} sx={sx}>
          <EmailIcon />
          <Link href={`mailto:${user.email}`} underline="hover" color="inherit">
            {user.email}
          </Link>
        </Typography>
      )}

      {showPhone && user.phoneNumber && (
        <Typography variant={variant} color={color} sx={{ ...sx }}>
          <PhoneIcon />
          <Link href={toTelHref(user.phoneNumber)} underline="hover" color="inherit">
            {user.phoneNumber}
          </Link>
        </Typography>
      )}
      {showWeChat && user.weChatId && (
        <Typography
          variant={variant}
          color={color}
          sx={{ ...sx }}
          onClick={async () => {
            const ok = await copyTextToClipboardSilent(user.weChatId)
            if (ok) bar.info('WeChat ID copied to clipboard')
            else bar.error('Failed to copy WeChat ID')
          }}
          title="Click to copy WeChat ID"
        >
          <IoLogoWechat style={{ fontSize: '1.5rem' }} /> {user.weChatId}
        </Typography>
      )}
    </Box>
  )
}
